import { Expose } from "class-transformer";
import { IsString } from "class-validator";

export class WorkFlowDataModel {
  @IsString()
  @Expose()
  key!: string;
  @IsString()
  @Expose()
  value!: string;
}
